import React from "react";
import styled from "styled-components";
import { flexCenter } from "@components/mixins";

const HashtagWrapper = styled.div`
    ${flexCenter};

    span {
        font-family: ${({ theme }) => theme.ff.Cormorant};
        font-size: ${({ theme }) => theme.fz.XXS};
        color: ${({ theme }) => theme.colors.black};
        font-weight: ${({ theme }) => theme.fw.semiBold};
        text-transform: lowercase;
        margin: 10px 10px 0 0;
    }
`;

const HashtagsContainer = ({ hashtags } = { hashtags: [] }) => {
    if (!hashtags.length) return null;

    const hashtagElements = hashtags.map((hash, i) => (
        <span key={i}>#{hash}</span>
    ));

    return (
        (hashtagElements && (
            <HashtagWrapper>{hashtagElements}</HashtagWrapper>
        )) ||
        null
    );
};

export default HashtagsContainer;
